import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100dvh - 6.4rem);

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    max-height: 54rem;
  }
`;
